import { render, staticRenderFns } from "./FabricYarnTypeIndex.vue?vue&type=template&id=2483bbcc&scoped=true&"
import script from "./FabricYarnTypeIndex.vue?vue&type=script&lang=js&"
export * from "./FabricYarnTypeIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2483bbcc",
  null
  
)

export default component.exports